import React from 'react';
import { motion } from 'framer-motion';
export function GridBackground() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-597">
      {/* Base light background */}
      <div className="absolute inset-0 bg-snakker-bg" data-id="element-598" />

      {/* Subtle radial color washes for depth */}
      <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] bg-snakker-primary/[0.06] blur-[120px] rounded-full" data-id="element-599" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] bg-snakker-secondary/[0.05] blur-[150px] rounded-full" data-id="element-600" />
      <div className="absolute top-[40%] left-[40%] w-[30%] h-[30%] bg-snakker-primary/[0.03] blur-[100px] rounded-full" data-id="element-601" />

      {/* Thin grid lines (dark on light) */}
      <div className="absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: `
            linear-gradient(to right, #0d0f14 1px, transparent 1px),
            linear-gradient(to bottom, #0d0f14 1px, transparent 1px)
          `,
      backgroundSize: '4rem 4rem',
      maskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)'
    }} data-id="element-602" />
    </div>;
}